// .com Routing for reference : https://github.com/1stdibs/1stdibs.com/blob/master/dibs/application/config/routes.php
// NOTE* For the time being we are ignoring the /amp (Accelerated Mobile Pages) as they are housed in .com
export const searchBrowse = [
    // more from seller
    { path: '/more-from-seller/:param([\\s\\S]*)?' },
    // fashion-jewelry
    { path: '/fashion-jewelry/:param([\\s\\S]*)?' },
    // multi-purpose route for collections, dealers, ... sale.
    {
        path:
            '/:segment(collections|dealers|locations|creators|associations|sale)/:param([\\s\\S]*)?',
    },
    // /contemporary/featured/* and /contemporary/* and
    { path: '/contemporary(/featured)?/:param([\\s\\S]*)?' },
    // /dealers/{url-label}/ and /dealers/{url-label}/shop/...params
    { path: '/dealers/:param([\\s\\S]*)/shop/:param([\\s\\S]*)?' },
    // recognized dealers
    { path: '/recognized-dealers/:param([\\s\\S]*)?' },
    // fair warning
    { path: '/fair-warning/:param([\\s\\S]*)?' },
    // browse categories
    { path: '/:vertical(furniture|fashion|jewelry|art)/:categories([\\s\\S]*)*?' },
    // search page
    { path: '/search/:param([\\s\\S]*)?' },
];
